export const record = {
  name: "record" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="currentColor"><path fill-rule="evenodd" d="M12 4.318a8.182 8.182 0 1 0 0 16.364 8.182 8.182 0 0 0 0-16.364ZM2 12.5c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm10-.101a.101.101 0 1 0 0 .202.101.101 0 0 0 0-.202Zm-1.92.101a1.92 1.92 0 1 1 3.84 0 1.92 1.92 0 0 1-3.84 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["record"],
  category: "media" as const,
};
